import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  buttonText: {
    defaultMessage: 'Process Return + {isRefund, select, true {Refund Customer} other {Issue Invoice}}',
    description: 'Text for the button that processes the return request',
    id: 'xYcUJ5',
  },
  returnProcessingErrorTitle: {
    defaultMessage: 'Error processing return',
    description: 'Title for error notification when processing return fails',
    id: 'YWIR1j',
  },
  returnProcessingErrorContent: {
    defaultMessage: 'Unable to process return at this time. Please try again later.',
    description: 'Content for error notification when processing return fails',
    id: 'y7zKk8',
  },
  returnProcessingSuccessTitle: {
    defaultMessage: 'Return processed successfully',
    description: 'Title for success notification when processing return succeeds',
    id: 'w8CFpK',
  },
});
